import React, { Component } from 'react';
import styled from 'styled-components'
import cssVar from '../../styles/variables'

import { inject, observer } from 'mobx-react'
import config from 'react-global-configuration';

import { FullWidthSection } from '../marketing/MarketingStyles';

@inject('utilStore')
@observer
class PromotionVideoSection extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {

    const video = this.props.utilStore.util[this.props.utilTarget || 'promotion_video']

    console.log(video);


    return (
      <FullWidthSection>
        <PromotionVideoFrame width="560" height="315" src={ video && video.src + "?modestbranding=1&rel=0&showinfo=0" } title="Promotion Video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></PromotionVideoFrame>
      </FullWidthSection>
    )
  }
}

export default PromotionVideoSection

const PromotionVideoFrame = styled.iframe `
  width: 100%;
  max-height: calc(100vh - ${ cssVar.headerHeight }px);
  height: calc(100vw / 16 * 9);
  margin-top: 30px;
  margin-bottom: -10px;
`



// WEBPACK FOOTER //
// /src/components/marketing/PromotionVideoSection.js